<template>
	<div>
		<el-drawer
			:visible="true"
			@close="reset"
			style="border-radius: 0 25px 0 25px; z-index: 100"
			direction="rtl"
			:with-header="false"
			size="80%"
		>
			<div v-if="element != undefined">
				<div class="drawer-header">
					<div style="margin-top: auto; margin-bottom: auto; margin-left: 10px">
						<el-tag v-if="isActive == 0" effect="dark" type="success">{{ $t("active") }}</el-tag>
						<el-tag v-else-if="isActive == -1" effect="dark" type="danger">{{ $t("expired") }}</el-tag>
						<el-tag v-if="isActive == 1" effect="dark">{{ $t("waiting") }}</el-tag>
					</div>
					<span class="title" style="margin-left: 5px">{{ $t("payment") + ": " + element.id }}</span>
					<div style="margin-left: auto; margin-right: 0; margin-top: auto; margin-bottom: auto">
						<md-button class="md-icon-button" @click="reset">
							<md-icon style="color: white">close</md-icon>
						</md-button>
					</div>
				</div>
				<div class="drawer-body" :key="element.id">
					<div class="container-tab">
						<div
							v-for="(t, $index) in tabs"
							:key="$index"
							:class="{ 'tab-effect': tab !== $index }"
							class="tab"
							@click="tab = $index"
						>
							<span :class="{ 'tab-selected': tab === $index }">{{ $t(t.translationKey) }}</span>
						</div>
					</div>

					<div v-if="tab == 0" :style="{ height: height + 'px' }">
						<div style="display: flex">
							<div style="flex: 1; padding-left: 15px">
								<h1>{{ element.subscription.name }}</h1>
							</div>
							<div
								style="
									display: flex;
									justify-content: flex-end;
									align-items: center;
									width: 25%;
									padding-right: 15px;
								"
								v-if="tab == 0"
							>
								<option-button
									:buttons="buttons"
									:show="true"
									@save="handleSave"
									@clear="handleClear"
									@delete="deleting = true"
									@open="linkTo"
								/>
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("id") }}</strong>
							</div>
							<div class="value">
								<el-input v-model="element.id" :disabled="true" />
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("subscription") }}</strong>
							</div>
							<div class="value">
								<el-input v-model="element.subscription.name" :disabled="true" />
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("school") }}</strong>
							</div>
							<div class="value" style="display: flex">
								<el-input v-model="element.organization.name.String" :disabled="true" />
								<el-tooltip placement="top">
									<div slot="content">{{ $t("open") }}</div>
									<md-button
										style="background-color: #90a4ae"
										class="md-icon-button md-elevation-4"
										@click="linkTo"
									>
										<md-icon style="color: white">open_in_new</md-icon>
									</md-button>
								</el-tooltip>
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("amount") }}</strong>
							</div>
							<div class="value">
								<el-input-number
									v-model="element.amount"
									:precision="2"
									:min="0"
									@change="edit = true"
								/>
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("valid-from") }}</strong>
							</div>
							<div class="value">
								<el-date-picker format="dd/MM/yyyy" v-model="valid_from" :clearable="false" />
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("valid-until") }}</strong>
							</div>
							<div class="value">
								<el-date-picker format="dd/MM/yyyy" v-model="valid_until" :clearable="false" />
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("created-at") }}</strong>
							</div>
							<div class="value" style="padding: 10px">
								{{ moment(element.created_at).format("DD/MM/YYYY HH:mm") }}
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("updated-at") }}</strong>
							</div>
							<div class="value" style="padding: 10px">
								{{ moment(element.updated_at).format("DD/MM/YYYY HH:mm") }}
							</div>
						</div>
						<div style="width: 80%; margin-left: auto; margin-right: auto">
							<el-alert
								v-if="another_one"
								:title="$t('another-subscription-active-found')"
								type="error"
								effect="dark"
							>
							</el-alert>
						</div>
					</div>
					<div v-if="tab == 1" :style="{ height: height + 'px' }">
						<subscription-form :subscription="element.subscription" :editable="false" />
					</div>
				</div>
			</div>
		</el-drawer>
		<div v-if="deleting">
			<delete-confirm-modal
				:title="$t('confirmation-delete-title')"
				:content="$t('confirmation-delete-text')"
				@close="handleDelete"
			/>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { mapGetters, mapActions } from "vuex"
import OptionButton from "@/modules/_common/button/option-button.vue"
import SubscriptionForm from "@/modules/datas/subscriptions/subscriptions-components/subscriptions-form.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal"

export default {
	components: {
		SubscriptionForm,
		OptionButton,
		DeleteConfirmModal
	},
	name: "payment-details",
	data() {
		return {
			element: undefined,
			height: window.innerHeight - 100,
			tabs: [{ translationKey: "general" }, { translationKey: "subscription" }],
			tab: -1,
			buttons: [],
			valid_until: undefined,
			valid_from: undefined,
			another_one: false,
			deleting: false,
			edit: false
		}
	},
	watch: {
		tab: function () {
			if (this.tab == 0) {
				this.buttons = ["delete"]
			} else {
				this.buttons = ["open"]
			}
		},

		valid_until: function () {
			if (this.valid_until != this.element.valid_until && this.buttons.indexOf("save") == -1)
				this.buttons = ["save", "clear"]
		},

		valid_from: function () {
			if (this.valid_from != this.element.valid_from && this.buttons.indexOf("save") == -1)
				this.buttons = ["save", "clear"]
		},
		edit: function () {
			if (this.edit) {
				this.buttons = ["save", "clear"]
			}
		}
	},
	computed: {
		...mapGetters({
			payment: "payment/payment"
		}),
		isActive: function () {
			var today = new Date()
			if (today > new Date(this.element.valid_until)) return -1
			if (today > new Date(this.element.valid_from) && today < new Date(this.element.valid_until)) return 0
			else return 1
		}
	},
	async created() {
		this.tab = 0
		if (this.payment == undefined && this.$route.params.payment_id) {
			var result = await this.doGetById(this.$route.params.payment_id)
			this.element = result
			this.valid_until = result.valid_until
			this.valid_from = result.valid_from
		} else {
			this.element = { ...this.payment }
			this.valid_until = this.payment.valid_until
			this.valid_from = this.payment.valid_from
		}
	},
	methods: {
		...mapActions({
			doGetById: "payment/doGetById",
			doMutate: "payment/doMutate"
		}),
		reset: function () {
			this.doMutate({ element: "payment", value: undefined })
			this.$router.replace({ path: "/users/payments" })
		},

		handleSave: function () {
			var payload = {
				id: this.element.id,
				valid_until: this.valid_until,
				valid_from: this.valid_from,
				organization_id: this.element.organization_id,
				amount: this.element.amount
			}
			axios
				.post(process.env.VUE_APP_API_URL + "/api/payments/update", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					if (res.data) {
						this.element.valid_until = this.valid_until
						this.element.valid_from = this.valid_from
					}
					this.$notification("success", this.$t("save-successful"), "", 4000)

					this.handleClear()
					this.$emit("update", this.element)
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
				})
		},

		handleClear: function () {
			this.buttons = ["delete"]
			this.valid_until = this.element.valid_until
		},

		handleDelete: function (value) {

			if (value){

				axios
				.delete(process.env.VUE_APP_API_URL + "/api/payments/"+this.$route.params.payment_id, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(() => {
					this.$notification("success", this.$t("deleted-successfully"), "", 4000)
					this.$emit("update", this.element)
				})
				.catch(err => {
					this.$processError(this.$t("delete-error"), err.response.data.Message)
				})
			}

			this.deleting = false
		},

		linkTo() {
			const route =
				this.tab === 0
					? { name: "users.schools.school_id", params: { school_id: this.element.organization_id } }
					: {
							name: "datas.subscriptions.subscription_id",
							params: { subscription_id: this.element.subscription_id }
					  }
			this.$router.push(route)
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-drawer";
@import "src/assets/scss/my-form";
@import "src/assets/scss/my-tab";

.data-item {
	width: 80%;
}
</style>
